import React from 'react'
import {Link} from "react-router-dom";
import projects from "../Data/projects";


export default function FeaturedWork(){
    const featured = projects.slice(0, 2);

    return(
        <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-center mt-10 mb-2">
                Other Projects
            </h2>
            <div className="grid gap-6 sm:gap-8 grid-cols-1 sm:grid-cols-2 mb-10">
                {featured.map((project) => (
                    <Link
                        key={project.id}
                        to={`/projects/${project.id}`}
                        className="block group"
                    >
                        <article className="bg-gradient-to-br from-[#ECE9E6] to-[#ECE9E6] min-h-[31vh] rounded-2xl overflow-hidden shadow-md transition-transform duration-200 group-hover:-translate-y-1 group-hover:shadow-xl flex flex-col items-center text-center p-4">
                            <div className="w-20 h-20 mb-4 flex items-center justify-center rounded-lg bg-stone-100">
                                <img
                                    src={project.thumbnail}
                                    alt={project.title}
                                    className="w-12 h-12 object-contain"
                                />
                            </div>
                            <h3 className="text-lg sm:text-xl font-semibold text-stone-800 group-hover:text-blue-600 transition-colors">
                                {project.title}
                            </h3>
                            <p className="mt-2 text-sm sm:text-base text-gray-600">
                                {project.description}
                            </p>
                            <div className="mt-4 flex flex-wrap justify-center gap-2">
                                {project.tags?.map((tag, index) => (
                                    <span
                                        key={index}
                                        className="px-2 p-1 text-xs sm:text-sm bg-stone-200 text-stone-700 rounded-full"
                                    >
                                                {tag}
                                            </span>
                                ))}
                            </div>
                        </article>
                    </Link>
                ))}
            </div>



        </section>

    )
}